import { DataTableHeader } from './DataTableHeader';

export type DataTable<T = any> = {
    dataRows: T[],
    headers: DataTableHeader[]
}

export const emptyDataTable: DataTable<any> = {
    dataRows: [],
    headers: []
}